export default "__VITE_ASSET__BcgOvjDV__"